/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import React from 'react';
import {
  TableContainer,
  TableHead,
  Table,
  TableCell,
  TableRow,
  TableBody,
  CircularProgress,
  Box,
  Typography,
  useTheme,
  Chip,
  LinearProgress,
  ButtonBase,
  Avatar,
  Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CloudOffRounded } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { IconArrowRight, IconPencil } from '@tabler/icons-react';
// import { currencyFormatter, formatDate } from '../../helpers';
// import config from '../../config';
import { formatDate } from 'src/utils';
import appConfig from 'src/config';
import EmptyComponent from '../EmptyComponent';

export default function UserListTable({ data, loading }) {
  const globalTheme = useTheme();
  const navigate = useNavigate();
  const { palette } = globalTheme;

  const { roles, userStatuses } = useSelector((state) => state.app);

  const headers = [
    { id: 1, label: 'User', key: 'user' },
    { id: 2, label: 'Phone Number', key: 'phone' },
    { id: 3, label: 'Email', key: 'email' },
    { id: 4, label: 'Date Joined', key: 'createdAt' },
    { id: 5, label: 'Role', key: 'role' },
    { id: 7, label: 'Gender', key: 'gender' },
    { id: 8, label: 'Status', key: 'status' },
    { id: 9, label: 'Action', key: 'action' },
  ];

  const getRole = (roleId) => {
    const role = roles.find((item) => item.id === roleId);
    return role;
  };

  const getGender = (gender) => (gender === 'M' ? 'Male' : 'Female');

  const buildStatus = (statusId) => {
    let color = 'warning';
    const selectedStatus = userStatuses.find((item) => item.id === statusId);
    if (!selectedStatus) return { value: 'Uknown', color };

    if (selectedStatus.abbreviation === 'ACT') {
      color = 'success';
    } else if (selectedStatus.abbreviation === 'DSD') {
      color = 'default';
    } else if (selectedStatus.abbreviation === 'SSD') {
      color = 'error';
    } else if (selectedStatus.abbreviation === 'PND') {
      color = 'warning';
    } else {
      color = 'error';
    }

    return { value: selectedStatus.name, color };
  };

  const navigateToDetails = (item) => {
    navigate(`${appConfig.routes.usersPath}/${item.id}`, { state: item });
  };

  return (
    <>
      {loading && (
      <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
      )}

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                >
                  <Typography sx={{ fontWeight: 'bold' }}>{column.label}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {!loading && data.length === 0 && (
          <TableBody>
            <TableRow style={{ height: 300 }}>
              <TableCell colSpan={12}>
                <EmptyComponent />
              </TableCell>
            </TableRow>
          </TableBody>
          )}

          {data.length > 0 && (
          <TableBody sx={{ }}>

            {data.map((item) => (
              <TableRow
                hover
                key={item.id}
              >
                <TableCell sx={{}}>
                  <Stack direction="row" alignContent="center" alignItems="center">
                    <Avatar alt="Profile pic" src={item.profilePicture} />
                    <Typography sx={{ ml: 1 }}>
                      {item.firstName}
                      {' '}
                      {item.lastName}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell>{item.phone}</TableCell>
                <TableCell>{item.email}</TableCell>
                <TableCell>
                  {formatDate(item.createdAt)}
                </TableCell>
                <TableCell>
                  {getRole(item.roleId).name}
                </TableCell>
                <TableCell>
                  {item.gender ? getGender(item.gender) : ''}
                </TableCell>

                <TableCell>
                  <Chip
                    color={buildStatus(item.statusId).color}
                    label={buildStatus(item.statusId).value}
                    sx={{ minWidth: '80px' }}
                  />
                </TableCell>
                <TableCell>
                  <ButtonBase
                    sx={{
                      borderRadius: '50px',
                      padding: 1,
                    }}
                    onClick={() => navigateToDetails(item)}
                  >
                    <IconPencil color={palette.primary.main} />
                  </ButtonBase>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          )}
        </Table>
      </TableContainer>
    </>
  );
}

UserListTable.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool.isRequired,
};
